import yup from "yup";

export const getInitialValues = questions =>
  questions.reduce(
    (acc, { id, type }) => ({
      ...acc,
      [id]:
        type === "CHAR" || type === "CHOI"
          ? void 0
          : type === "MULT" ? [] : null
    }),
    {}
  );

export const getValidationSchema = questions =>
  yup.object().shape(
    questions.reduce((acc, { id, type, isRequired }) => {
      const message = "This field is required";
      const strRequired = yup.string().required(message);
      const arrRequired = yup
        .array()
        .required(message)
        .compact();
      const mixedRequired = yup.mixed().required(message);

      return {
        ...acc,
        [id]:
          type === "CHAR" || type === "CHOI"
            ? strRequired
            : type === "MULT" ? arrRequired : mixedRequired
      };
    }, {})
  );



// WEBPACK FOOTER //
// ./src/modules/user/onboarding/utils.js